"use client";

import { createContext } from "react";

import { AuthContext } from "./types";

export const authContext = createContext<AuthContext | undefined>(undefined);
